<button
  data-testid="component-button"
  [ngClass]="classes()"
  [type]="type()"
  [style.min-width.px]="width()"
  [ariaBusy]="state() === 'loading'"
  [ariaLabel]="buttonAriaLabel()"
  [attr.role]="overrideRole()"
  [attr.aria-checked]="overrideAriaChecked()"
  [attr.aria-pressed]="overrideAriaPressed()"
>
  @switch (state()) {
    @case ("default") {
      @if (icon(); as icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }

      <span data-testid="component-button-content" class="text-container" #labelText>
        <ng-content></ng-content>

        @if (label(); as label) {
          {{ label }}
        }
      </span>

      @if (hasMenu()) {
        <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
      }
    }

    @case ("loading") {
      <app-pan-spinner data-testid="component-button-loading" [size]="size()" [color]="color()"></app-pan-spinner>
    }
  }
</button>
